import userGroupService from "services/maintenance/userGroupService";
import UserGroupForm from "features/maintenance/components/DedicatedForms/UserGroupForm";
import { GroupAddOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const isEditing = (formData) => {
    return !!formData?.id;
};

const userGroupResource = {
    title: "User Group",
    singular: "User Group",
    displayField: "User Groups",
    editableForm: UserGroupForm,
    pageIcon: GroupAddOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.USER_GROUP,
    service: userGroupService,

    columns: [
        {
            field: "name",
            header: "User Group"
        }
    ],

    fields: [
        {
            name: "name",
            label: "User Group",
            type: "text",
            required: true,
            unique: true,
            disabledResolver: isEditing
        }
    ],
    searchFields: ["name"]
};

export default userGroupResource;
